import logo from './logo.svg';
import './App.css';
import CurrencySelect from './components/CurrencySelect';


export default function App() {
  return (
    <>
      <h1>Currency Converter</h1>
      <div className='main-box'>
        <CurrencySelect />
      </div>
    </>

  );
}
